<template>
    <div id="loader">
      <div id="escapingBallG" v-bind:class="{yellow: isYellow}">
        <div id="escapingBall_1" class="escapingBallG">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "loader",
  props: ['isYellow']
}
</script>

<style scoped>
#escapingBallG{
position:relative;
width:146px;
height:50px;
}
.yellow .escapingBallG{
  background-color:#f8d83c;
}

.escapingBallG{
background-color:#4dc499;
position:absolute;
top:0;
left:0;
width:50px;
height:50px;
-moz-border-radius:25px;
-moz-animation-name:bounce_escapingBallG;
-moz-animation-duration:2s;
-moz-animation-iteration-count:infinite;
-moz-animation-timing-function:linear;
-moz-animation-delay:0s;
-moz-transform:scale(0.5, 1);
-webkit-border-radius:25px;
-webkit-animation-name:bounce_escapingBallG;
-webkit-animation-duration:2s;
-webkit-animation-iteration-count:infinite;
-webkit-animation-timing-function:linear;
-webkit-animation-delay:0s;
-webkit-transform:scale(0.5, 1);
-ms-border-radius:25px;
-ms-animation-name:bounce_escapingBallG;
-ms-animation-duration:2s;
-ms-animation-iteration-count:infinite;
-ms-animation-timing-function:linear;
-ms-animation-delay:0s;
-ms-transform:scale(0.5, 1);
-o-border-radius:25px;
-o-animation-name:bounce_escapingBallG;
-o-animation-duration:2s;
-o-animation-iteration-count:infinite;
-o-animation-timing-function:linear;
-o-animation-delay:0s;
-o-transform:scale(0.5, 1);
border-radius:25px;
animation-name:bounce_escapingBallG;
animation-duration:2s;
animation-iteration-count:infinite;
animation-timing-function:linear;
animation-delay:0s;
transform:scale(0.5, 1);
}
@-moz-keyframes bounce_escapingBallG{
0%{
left:0px;
-moz-transform:scale(0.5, 1);
}
25%{
left:48px;
-moz-transform:scale(1, 0.5);
}
50%{
left:121px;
-moz-transform:scale(0.5, 1);
}
75%{
left:48px;
-moz-transform:scale(1, 0.5);
}
100%{
left:0px;
-moz-transform:scale(0.5, 1);
}
}
@-webkit-keyframes bounce_escapingBallG{
0%{
left:0px;
-webkit-transform:scale(0.5, 1);
}
25%{
left:48px;
-webkit-transform:scale(1, 0.5);
}
50%{
left:121px;
-webkit-transform:scale(0.5, 1);
}
75%{
left:48px;
-webkit-transform:scale(1, 0.5);
}
100%{
left:0px;
-webkit-transform:scale(0.5, 1);
}
}
@-ms-keyframes bounce_escapingBallG{
0%{
left:0px;
-ms-transform:scale(0.5, 1);
}
25%{
left:48px;
-ms-transform:scale(1, 0.5);
}
50%{
left:121px;
-ms-transform:scale(0.5, 1);
}
75%{
left:48px;
-ms-transform:scale(1, 0.5);
}
100%{
left:0px;
-ms-transform:scale(0.5, 1);
}
}
@-o-keyframes bounce_escapingBallG{
0%{
left:0px;
-o-transform:scale(0.5, 1);
}
25%{
left:48px;
-o-transform:scale(1, 0.5);
}
50%{
left:121px;
-o-transform:scale(0.5, 1);
}
75%{
left:48px;
-o-transform:scale(1, 0.5);
}
100%{
left:0px;
-o-transform:scale(0.5, 1);
}
}
@keyframes bounce_escapingBallG{
0%{
left:0px;
transform:scale(0.5, 1);
}
25%{
left:48px;
transform:scale(1, 0.5);
}
50%{
left:121px;
transform:scale(0.5, 1);
}
75%{
left:48px;
transform:scale(1, 0.5);
}
100%{
left:0px;
transform:scale(0.5, 1);
}
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue